import React, { useState } from "react";
import "./Testimonial.scss";
import images from "../../constants/images";

const testimonials = [
  {
    id: 1,
    text:
      "Outstanding work by Ar. Saif on a complex commercial Revit model. The level of detail, accuracy, and organisation was excellent, and communication was clear and proactive throughout.",
    name: "Darryl Wylie",
    role: "Fiverr Client",
    platform: "Fiverr",
    logo: images.fiver,
    proof: images.Fiverr_Review_Darryl_Wyliefrom,
  },

  {
    id: 2,
    text:
      "Very good person. Very good and fast cooperation. Will come again, thank you!",
    name: "Christos Sparta",
    role: "Fiverr Client",
    platform: "Fiverr",
    logo: images.fiver,
    proof: images.Fiverr_Review_Christos_Sparta,
  },

  {
    id: 3,
    text:
      "Saif was great to work with. He understood what I needed, kept good communication, and delivered quality work on time. Would definitely work with him again.",
    name: "Ehud Sourjon",
    role: "Upwork Client",
    platform: "Upwork",
    logo: images.upwork,
    proof: images.Upwork_Review_Ehud_Sourjon,
  },

  {
    id: 4,
    text:
      "Excellent experience with Saif. Clear communication, fast turnaround, and high-quality professional output. Highly recommended.",
    name: "MO Ali",
    role: "Upwork Client",
    platform: "Upwork",
    logo: images.upwork,
    proof: images.Upwork_Review_MO_Ali,
  },

  {
    id: 5,
    text:
      "I’ve worked with Saif on multiple architectural drafting and 3D rendering projects. The quality has been consistently strong with accurate scaling and photorealistic results.",
    name: "Lulu Logan",
    role: "LinkedIn Client",
    platform: "LinkedIn",
    logo: images.linkedin,
    proof: images.Linkedin_Review_Lulu_Loganfrom,
  },

  {
    id: 6,
    text:
      "Saif is highly knowledgeable, responsive, and consistently delivers quality work with a quick turnaround time. I’d gladly recommend him to anyone.",
    name: "Rafsaan Rubail",
    role: "LinkedIn Client",
    platform: "LinkedIn",
    logo: images.linkedin,
    proof: images.Linkedin_Review_Rafsaan_Rubail,
  },
];


const Testimonials = () => {
  const [activeProof, setActiveProof] = useState(null);

  return (
    <section className="testimonials">
      <h2>Loved by customers</h2>

      <div className="testimonial-grid">
        {testimonials.map((item) => (
          <div className="testimonial-card" key={item.id}>
            <p className="review-text">{item.text}</p>

            <div className="testimonial-footer">
              <img src={item.logo} alt={item.platform} />
              <div>
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </div>
            </div>

            <button
              className="learn-more"
              onClick={() => setActiveProof(item.proof)}
            >
              Learn more →
            </button>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {activeProof && (
        <div className="modal-overlay" onClick={() => setActiveProof(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={activeProof} alt="Review proof" />
            <button className="close-btn" onClick={() => setActiveProof(null)}>
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
